import { render } from "./infoOfDocuments.vue?vue&type=template&id=1886a811"
import script from "./infoOfDocuments.vue?vue&type=script&lang=js"
export * from "./infoOfDocuments.vue?vue&type=script&lang=js"

import "./infoOfDocuments.vue?vue&type=style&index=0&id=1886a811&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__